<script lang="ts" setup>
import {
  NXGDSNotificationType,
  NXGDSNotificationVariants,
  NXGDSNotification
} from '@nsftx/seven-nxg-design-system'
import { useServiceModeStore } from '@/stores/serviceMode/serviceModeStore'

const serviceModeStore = useServiceModeStore()
</script>

<template>
  <NXGDSNotification
    v-if="serviceModeStore.serviceMode"
    class="sbo-service-mode-banner"
    block
    :closable="false"
    :type="NXGDSNotificationType.Banner"
    :text="[$t('common_service_mode_banner')]"
    :variant="NXGDSNotificationVariants.warning"
  />
</template>
<style lang="scss" scoped>
.sbo-service-mode-banner {
  grid-area: banner;
}
</style>
